import $ from 'jquery';
import RimgShopify from '@pixelunion/rimg-shopify';

export default class StaticPassword {
  constructor(section) {
    this.$el = $(section.el);
    this.$newsletterForm = $('.newsletter-section', this.$el);
    this.$newsletterToggle = $('[data-newsletter-toggle]', this.$el);
    this.$passwordForm = $('[data-password-form]', this.$el);
    this.$passwordToggle = $('[data-password-toggle]', this.$el);

    $('[data-password-trigger]', this.$el).on('click', (event) => this.togglePasswordForm(event));

    this.hasErrors = this.$passwordForm.find('.has-errors').length;

    RimgShopify.init();

    if (this.hasErrors) {
      this.togglePasswordForm(false, true);
    }
  }

  togglePasswordForm(event, hideNewsletter) {
    if (event == null) { event = false; }
    if (hideNewsletter == null) { hideNewsletter = false; }
    if (event) { event.preventDefault(); }

    if (this.$passwordForm.hasClass('visible' || hideNewsletter)) {
      this.$newsletterForm.addClass('visible').removeClass('hidden');
      this.$newsletterToggle.addClass('visible').removeClass('hidden');

      this.$passwordForm.addClass('hidden').removeClass('visible');
      this.$passwordToggle.addClass('hidden').removeClass('visible');
    } else {
      this.$passwordForm.addClass('visible').removeClass('hidden');
      this.$passwordToggle.addClass('visible').removeClass('hidden');

      this.$newsletterForm.addClass('hidden').removeClass('visible');
      this.$newsletterToggle.addClass('hidden').removeClass('visible');
    }
  }
}

$(() => window.theme = new StaticPassword({ el: document.body }));
